<template>
  <div class="vr mx-2" style="align-self: center; height: 1.2rem"></div>
</template>
